import {
  take,
  put,
  call,
  all,
  takeEvery,
} from 'redux-saga/effects';
import { holidaysActions as actions, notificationActions } from '../actions';
import { holidaysService } from '../services';

// create holiday
function* handleCreateHolidayRequest() {
  const action = yield take(actions.createHolidayRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.createHoliday, dataParams);
    if (res.isError) {
      yield put(actions.createHolidayError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createHolidaySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createHolidayError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// get holiday
function* handleGetHolidayRequest() {
  const action = yield take(actions.getHolidayRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.getHoliday, dataParams);
    if (res.isError) {
      yield put(actions.getHolidayError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.getHolidaySuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.getHolidayError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// update holiday
function* handleUpdateHolidayRequest() {
  const action = yield take(actions.updateHolidayRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.updateHoliday, dataParams);
    if (res.isError) {
      yield put(actions.updateHolidayError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateHolidaySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateHolidayError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// delete holiday
function* handleDeleteHolidayRequest() {
  const action = yield take(actions.deleteHolidayRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.deleteHoliday, dataParams);
    if (res.isError) {
      yield put(actions.deleteHolidayError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteHolidaySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteHolidayError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


// update holiday
function* handleSampleDownloadRequest() {
  const action = yield take(actions.sampleDownloadRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.downloadSample, dataParams);
    if (res.isError) {
      yield put(actions.sampleDownloadError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.sampleDownloadSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.sampleDownloadError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// update holiday
function* handleUploadHolidayRequest() {
  const action = yield take(actions.uploadHolidayRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(holidaysService.uploadHoliday, dataParams);
    if (res.isError) {
      yield put(actions.uploadHolidayError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.uploadHolidaySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.uploadHolidayError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

// -----------Watchers-------------
function* handleCreateHolidayWatcher() {
  yield takeEvery(
    actions.createHolidayRequest,
    handleCreateHolidayRequest,
  );
}

function* handleGetHolidayWatcher() {
  yield takeEvery(
    actions.getHolidayRequest,
    handleGetHolidayRequest,
  );
}

function* handleUpdatetHolidayWatcher() {
  yield takeEvery(
    actions.updateHolidayRequest,
    handleUpdateHolidayRequest,
  );
}

function* handleDeleteHolidayWatcher() {
  yield takeEvery(
    actions.deleteHolidayRequest,
    handleDeleteHolidayRequest,
  );
}

function* handleSampleDownloadWatcher() {
  yield takeEvery(
    actions.sampleDownloadRequest,
    handleSampleDownloadRequest,
  );
}

function* handleUploadHolidayWatcher() {
  yield takeEvery(
    actions.uploadHolidayRequest,
    handleUploadHolidayRequest,
  );
}

function* rootEmployeeSaga() {
  yield all([
    handleCreateHolidayRequest(),
    handleCreateHolidayWatcher(),

    handleGetHolidayRequest(),
    handleGetHolidayWatcher(),

    handleUpdateHolidayRequest(),
    handleUpdatetHolidayWatcher(),

    handleDeleteHolidayRequest(),
    handleDeleteHolidayWatcher(),

    handleSampleDownloadRequest(),
    handleSampleDownloadWatcher(),

    handleUploadHolidayRequest(),
    handleUploadHolidayWatcher()
  ]);
}
export default rootEmployeeSaga;

